import styled from '@emotion/styled';
import { ButtonBase, Typography } from '@material-ui/core';
import AddCircle from '@material-ui/icons/AddCircle';
import { createElement, FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_LARGE, SPACING_UNIT } from '../../../constant/spacing';
import { gridLayoutContainer } from '../../../styleUtility/gridLayout';
import { InputtedCreativeFormat } from '../../../types/InputtedCreativeFormat';

type Props = {
  disabled?: boolean;
  creationSetIndex?: boolean;
  originalCreativeFormat?: InputtedCreativeFormat;
  onClick: () => void;
  className?: string;
};

const AddResizeFormatsButton: FC<Props> = ({ disabled = false, originalCreativeFormat, onClick, className }) => {
  // 選択されたフォーマットのPlacementのBasicMerchandise
  const selectedPlacementBasicMerchandise =
    originalCreativeFormat &&
    originalCreativeFormat.placement.basicMerchandises &&
    originalCreativeFormat.placement.basicMerchandises.find(
      (basicMerchandise) => basicMerchandise.creativeType!.key == originalCreativeFormat.creativeType.key,
    );

  // 選択されたフォーマットのリサイズ可不可フラグ
  const isResizable = selectedPlacementBasicMerchandise ? selectedPlacementBasicMerchandise.isResizable : false;
  const resizeSelectorDisabled = !isResizable || disabled;
  return (
    <>
      <FormatSelector component="div" disabled={resizeSelectorDisabled} onClick={onClick} className={className}>
        <StandbyIcon color={resizeSelectorDisabled ? 'disabled' : 'primary'} />
        <StandbyDescription variant="body2" color={resizeSelectorDisabled ? 'textSecondary' : 'inherit'}>
          {!originalCreativeFormat || isResizable ? (
            <FormattedMessage id="project_editing_page.basic_setting.creative_formats.add_formats" />
          ) : (
            <FormattedMessage id="project_editing_page.basic_setting.creative_formats.disable_resize" />
          )}
        </StandbyDescription>
      </FormatSelector>
    </>
  );
};

const FormatSelector = (styled(ButtonBase)(
  gridLayoutContainer({
    columns: ['100%'],
    rows: ['auto', 'auto'],
    areas: [['icon'], ['description']],
    alignItems: 'center',
    justifyItems: 'center',
  }),
  {
    width: '100%',
    height: '100%',
    padding: `${SPACING_LARGE}px 0`,
    cursor: 'pointer',
  },
) as unknown) as typeof ButtonBase;

const StandbyIcon = styled(AddCircle)({
  gridArea: 'icon',
  width: 48,
  height: 48,
});

const StandbyDescription = styled(Typography)({
  gridArea: 'description',
  marginTop: SPACING_UNIT,
});

export default AddResizeFormatsButton;
